import Error404 from "./404.js";

export default Error404;
